import React from "react";
import { Link } from "react-router-dom";
import { observer } from "mobx-react-lite";
import ApiData from "../../../api/ApiData";
import Loader from "../../Loader";
import { NoRightsMessage } from "../../UI/NoRightsMessage";

const partnerCardPath = (company) => {
  const inn = company?.inn;
  if (!inn) {
    return null;
  }
  return company.is_partner ? `/partners/${inn}` : `/company/${inn}`;
};

export const CompanyClientPartnersBlock = observer(({ companyId }) => {
  const loaded =
    companyId != null && ApiData.clientCompanyPartnersCompanyId === companyId;
  const links = loaded ? ApiData.clientCompanyPartners ?? [] : [];
  const rows = Array.isArray(links) ? links.filter((l) => l?.company) : [];

  return (
    <div className="req-item req-item--client-partners">
      <span className="req-label">Партнёры клиента:</span>
      <div className="req-value client-partners-list">
        {!loaded ? (
          <Loader />
        ) : ApiData.clientCompanyPartnersForbidden ? (
          <NoRightsMessage>Нет прав для просмотра партнёров клиента.</NoRightsMessage>
        ) : rows.length === 0 ? (
          <span className="req-value-muted">—</span>
        ) : (
          <ul className="client-partners-links">
            {rows.map((link) => {
              const company = link.company;
              const to = partnerCardPath(company);
              const label = `${company.name_company} / ${company.inn ?? "—"}`;
              const inactive = link.is_active === false;
              if (!to) {
                return (
                  <li
                    key={link.link_id ?? company.id}
                    className={inactive ? "client-partners-link--inactive" : undefined}
                  >
                    <span className={inactive ? "req-value-muted" : undefined}>
                      {label}
                    </span>
                  </li>
                );
              }
              return (
                <li
                  key={link.link_id ?? company.id}
                  className={inactive ? "client-partners-link--inactive" : undefined}
                >
                  <Link
                    to={to}
                    className={
                      inactive
                        ? "client-partners-link req-value-muted"
                        : "client-partners-link"
                    }
                  >
                    {label}
                  </Link>
                </li>
              );
            })}
          </ul>
        )}
      </div>
    </div>
  );
});
